import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { RegisterSmsRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { RegisterSmsResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const registerSms = (request: RegisterSmsRequest, options?: CashRequestOptions) =>
  post<RegisterSmsRequest, RegisterSmsResponse>('/2.0/cash/register-sms', request, { ...options, rejectOnError: true })
